import { navigateTo } from "client_legacy/ndaw/navigator";
import { isEmbeddedInMsTeamsAppCheck } from "./isEmbeddedInMsTeamsAppCheck";

export async function init(): Promise<void> {
	const isTeamsEmbed: boolean = await isEmbeddedInMsTeamsAppCheck();

	if (!isTeamsEmbed) {
		return;
	}

	const navigation: Navigation | undefined = window.navigation;

	if (!navigation) {
		console.error("Cannot apply special navigation rules for MS Teams embedded app, because navigation interception is not supported by browser.");
		return;
	}

	navigation.addEventListener(
		"navigate",
		(event: NavigateEvent): void => {
			const url: URL = new URL(event.destination.url);

			if (!isExternalUrl(url)) {
				return;
			}

			event.preventDefault();

			navigateTo(event.destination.url, true);
		}
	);
}

function isExternalUrl(url: URL): boolean {
	const { location } = window;

	if (url.origin !== location.origin) {
		return true;
	}

	return false;
}